import { RouterPaths } from '@/presentation/router/RouterPathsMapper'

function normalizeCode(code?: string | null): string | undefined {
  const trimmedCode = code?.trim()
  return trimmedCode ? trimmedCode.toUpperCase() : undefined
}

export interface ProcedureChartsSearchParams {
  code?: string
}

export function parseProcedureChartsSearchParams(search: string): ProcedureChartsSearchParams {
  const searchParams = new URLSearchParams(search)

  return {
    code: normalizeCode(searchParams.get('code'))
  }
}

export function getProcedureChartsPath(icao: string): string {
  const searchParams = new URLSearchParams()
  const code = normalizeCode(icao)

  if (code) {
    searchParams.set('code', code)
  }

  const queryString = searchParams.toString()

  return queryString ? `${RouterPaths.PROCEDURE_CHARTS}?${queryString}` : RouterPaths.PROCEDURE_CHARTS
}
